var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpperBodyWax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsdc: "http://purl.org/dc/elements/1.1/",
    xmlnscc: "http://creativecommons.org/ns#",
    xmlnsrdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnssvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnssodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsinkscape: "http://www.inkscape.org/namespaces/inkscape",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 38",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    className: "service-svgs pull-down",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#afafaf",
    strokeWidth: 1,
    "connector-curvature": 0,
    d: "M25.327,22.629c-0.426,1.021-0.561,2.143-0.389,3.236  c0.198,1.262,0.453,2.516,0.763,3.756c0.071,0.268,0.345,0.426,0.611,0.355c0.262-0.069,0.421-0.334,0.359-0.598  c-0.303-1.211-0.551-2.436-0.745-3.67c-0.144-0.911-0.031-1.844,0.323-2.696c2.704-6.495,3.973-13.499,3.718-20.531 c-0.012-0.276-0.246-0.489-0.521-0.478c-0.273,0.012-0.486,0.242-0.478,0.516C29.218,9.407,27.976,16.268,25.327,22.629  L25.327,22.629z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#afafaf",
    strokeWidth: 1,
    "connector-curvature": 0,
    d: "M6.674,22.629C4.024,16.266,2.782,9.406,3.032,2.518  c0.009-0.275-0.208-0.506-0.484-0.516C2.274,1.994,2.044,2.207,2.032,2.48C1.778,9.512,3.046,16.516,5.75,23.012  c0.355,0.852,0.466,1.785,0.324,2.696c-0.194,1.233-0.442,2.458-0.745,3.669c-0.063,0.27,0.103,0.538,0.372,0.602  c0.264,0.063,0.529-0.097,0.598-0.359c0.311-1.239,0.564-2.493,0.763-3.756c0.172-1.094,0.037-2.214-0.388-3.236L6.674,22.629z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "M23,9.52c0.276,0,0.5-0.224,0.5-0.5c0-0.275-0.224-0.5-0.5-0.5h-0.5  c-0.276,0-0.5,0.225-0.5,0.5c0,0.276,0.224,0.5,0.5,0.5H23z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "M6.819,12.81c1.755,0.087,3.513,0.087,5.268,0  c0.722-0.036,1.394-0.382,1.841-0.95l0.673-0.855c0.169-0.218,0.13-0.532-0.088-0.701c-0.217-0.168-0.527-0.131-0.698,0.082  l-0.673,0.855c-0.268,0.342-0.671,0.549-1.104,0.57c-1.722,0.086-3.447,0.086-5.17,0c-0.433-0.021-0.836-0.229-1.104-0.57  l-0.673-0.855c-0.172-0.215-0.486-0.251-0.703-0.079c-0.214,0.171-0.251,0.482-0.083,0.698l0.673,0.855  C5.426,12.428,6.097,12.773,6.819,12.81L6.819,12.81z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "M25.182,12.81c-1.755,0.087-3.514,0.087-5.269,0  c-0.723-0.036-1.394-0.382-1.841-0.95l-0.673-0.855c-0.169-0.218-0.13-0.531,0.088-0.701c0.216-0.168,0.527-0.132,0.698,0.082  l0.673,0.855c0.269,0.342,0.671,0.549,1.104,0.57c1.722,0.086,3.447,0.086,5.17,0c0.433-0.021,0.836-0.229,1.104-0.57l0.673-0.855  c0.173-0.215,0.488-0.249,0.703-0.076c0.212,0.17,0.249,0.479,0.083,0.695l-0.674,0.855C26.574,12.428,25.903,12.773,25.182,12.81  L25.182,12.81z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "M9,9.52c-0.276,0-0.5-0.224-0.5-0.5c0-0.275,0.224-0.5,0.5-0.5h0.5  c0.276,0,0.5,0.225,0.5,0.5c0,0.276-0.224,0.5-0.5,0.5H9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperBodyWax);
export default __webpack_public_path__ + "static/media/upperBodyWax.36813418773a34924e923458e7bc3655.svg";
export { ForwardRef as ReactComponent };